/* eslint-disable import/prefer-default-export */
export { default as MainFooter } from './MainFooter';
